var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as moment from 'moment';
import { Chart } from 'chart.js';
import { configLineChart } from '../shared/charts/line/line-chart.config';
/**
 * Mostly taken from https://github.com/cyberbeat/ChartJSTimescaleFillWithZerosPlugin/blob/35e67281662c4a7603346d50c9aae3ba13eafb29/FillScatteredTimeScaleDataPlugin.js
 */
var fillScatteredTimeScaleDataPlugin = {
    beforeUpdate: function (chart) {
        if (!chart.options.scales) {
            return;
        }
        var timeAxis = chart.options.scales.xAxes[0].time;
        if (!timeAxis || !timeAxis.fillGapsWithZeros) {
            return;
        }
        for (var i = 0; i < chart.data.datasets.length; i++) {
            var set = chart.data.datasets[i];
            if (!set.data.length) {
                continue;
            }
            var min = moment()
                .subtract(30, 'days')
                .startOf('day');
            var max = moment();
            var hash = {};
            for (var j = 0; j < set.data.length; j++) {
                // assume x is a Moment object
                var currentTimeOnX = set.data[j].x;
                var val = moment(set.data[j].x, timeAxis.parser);
                if (!min || min.diff(val) > 0) {
                    min = val;
                }
                if (!max || max.diff(val) < 0) {
                    max = val;
                }
                hash[currentTimeOnX] = 1;
            }
            for (var val = min; max.diff(val) > 0; val.add(1, timeAxis.unit)) {
                var value = val.format();
                if (!hash[value]) {
                    set.data.push({ x: moment(value), y: 0 });
                }
            }
            set.data.sort(function (a, b) { return (moment(a.x).diff(b.x) < 0 ? -1 : 1); });
        }
    }
};
Chart.pluginService.register(fillScatteredTimeScaleDataPlugin);
export var callVolumeChartConfig = {
    lineChartOptions: __assign({}, configLineChart.lineChartOptions, { scales: {
            yAxes: configLineChart.lineChartOptions.scales.yAxes,
            xAxes: [
                {
                    type: 'time',
                    time: {
                        unit: 'day',
                        displayFormats: {
                            day: 'M/D/YYYY'
                        },
                        min: moment().subtract(30, 'days'),
                        fillGapsWithZeros: true
                    },
                    gridLines: {
                        display: false
                    }
                }
            ]
        } }),
    lineChartType: 'line'
};
